import React, {Component} from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Recaptcha from 'react-google-recaptcha'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

import parse from 'html-react-parser'
import { navigate } from 'gatsby'

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"

class Form extends Component {

  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef();
  }

  handleChange = e => {
    let { form } = this.state
    if (e.target.name === 'type') {
      let current = form[e.target.name] || ''
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + ' ' + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(' ' + e.target.value, '')
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = value => {
    this.setState({ "g-recaptcha-response": value });
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    const formData = new FormData(this.form.current)
    formData.append('form-name', this.form.current.getAttribute("name"))
    formData.append('agent', this.props.email)
    const queryString = new URLSearchParams(formData).toString()

    this.setState({ result: 'success' })
    await fetch("https://hooks.zapier.com/hooks/catch/2181815/bxg78wo/?"+queryString)
  }

  render() {

    let props = {
      ref: this.form,
      name: 'agent_profile',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success') {

      navigate('/thank-you');
      return (
        <div className="signup__nav">
          <p>Thanks for getting in contact.<br /> I'll be in touch soon.</p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <form {...props}>
          <input type='hidden' name='source' value='agent_profile' />
          <p>How can we assist you?</p>
          <ul>
            <li>
              <input id={`checkbox_enquiry`} className='boxes' type='checkbox' name="checkbox_enquiry" onChange={this.handleChange} /> 
              <label htmlFor={`checkbox_enquiry`}>
                Sale Enquiry
              </label>
            </li>
            <li>
              <input id={`checkbox_appraisals`} className='boxes' type='checkbox' name="checkbox_appraisals" onChange={this.handleChange} />
              <label htmlFor={`checkbox_appraisals`}>
                Appraisals
              </label>
            </li>
            <li>
              <input id={`checkbox_request_callback`} className='boxes' type='checkbox' name="checkbox_request_callback" onChange={this.handleChange} />
              <label htmlFor={`checkbox_request_callback`}>
                Request Callback
              </label>
            </li>
            <li>
              <input id={`checkbox_general`} className='boxes' type='checkbox' name="checkbox_general" onChange={this.handleChange} />
              <label htmlFor={`checkbox_general`}>
                General
              </label>
            </li>
          </ul>
          <div className='signup__double'>
            <input type='text' name='fname' placeholder='First Name*' onChange={this.handleChange} required />
            <input type='text' name='lname' placeholder='Last Name*' onChange={this.handleChange} required />
          </div>
          <div className='signup__double'>
            <input type='email' name='email' placeholder='Email*' onChange={this.handleChange} required />
            <input type='text' name='phone' placeholder='Phone*' onChange={this.handleChange} required />
          </div>
          <textarea name='message' onChange={this.handleChange} placeholder='Leave a message' />
          <div className='recaptcha__wrapper'>
            <Recaptcha
              ref='recaptcha'
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className="contactbtn" type='submit'>Send Enquiry</button>
          { this.state.result !== '' &&
            <p className="paragraph" dangerouslySetInnerHTML={{ __html: this.state.msg }} />
          }
        </form>
      </div>  
    )
  }
}

const SuburbContact = ({office}) => {


  return (
    <section className='agent-contact' id='contact'>
      <div className='agent-contact__inner'>
        <Fade bottom distance='40px'>
          <div className='agent-contact__wrapper'>
            <div className='agent-contact__card'>
              { office.acf.featuredImage?.localFile && <GatsbyImage image={getImage(office.acf.featuredImage.localFile)} alt={office.title} /> }
              {office.title && <h3>{parse(office.title)}</h3> }
              <ul>
                {office.acf?.phone?.url &&
                  <li>
                    <Link to={office.acf.phone.url}>
                      <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 5.11475H8.56343V6.21106H0.0657959V5.11475Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.20636 9.33656L5.43848 8.56868L8.34453 5.66315L5.43848 2.75763L6.20636 1.98975L9.87925 5.66317L6.20636 9.33656Z" fill="#64656A"/>
                      </svg>
                      <span>{office.acf.phone.title}</span>
                    </Link>
                  </li>
                }
                { office.acf?.email?.url &&
                  <li>
                    <Link to={office.acf?.email?.url}>
                      <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.0657959 5.11475H8.56343V6.21106H0.0657959V5.11475Z" fill="#64656A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.20636 9.33656L5.43848 8.56868L8.34453 5.66315L5.43848 2.75763L6.20636 1.98975L9.87925 5.66317L6.20636 9.33656Z" fill="#64656A"/>
                      </svg>
                      <span>Email WHITEFOX</span>
                    </Link>
                  </li>
                }
              </ul>
              { office.acf.address && <p>{parse(office.acf.address)}</p> }
            </div>
            <div className='agent-contact__form'>
              <Form email={office.acf.email.title} />
            </div>
          </div>
        </Fade>
      </div>
    </section>
  )
}

export default SuburbContact
